import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop } from "vue-property-decorator";
import { TextValueItem } from "../../../models/TextValueItem";
import api from "@/services/api";
import { CommissioniPolizeItem } from "@/models/prodotti/commissioniPolizeItem";
import permessi from "@/config/permessi";
import editForm from "@/components/grid/edit/editForm.vue";

const _ENDPONT = api.endpoint.POLIZZE.COMMISSIONI_POLIZZE;
@Component({})
export default class CommissioniPolize extends gridComponentBase {
	get PERMESSI(): string[] { return [permessi.BK.Prodotti.POLIZZE]; }
	@Prop({ default: () => null }) prodottoID: number;
	@Prop({ default: () => null }) pacchettoID: number;
	editItem: CommissioniPolizeItem = new CommissioniPolizeItem();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";
	kendop: any = kendo;

	parametriProdotto: TextValueItem[] = [];
	beneficiari: TextValueItem[] = [];
	tipiPremio: TextValueItem[] = [];

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{ field: "prodottoID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{
				field: "parametroID",
				title: this.$i18n.t("generico.parametro").toString(),
				width: 70,
				filterable: true,
				hidden: this.pacchettoID ? true : false,
				values: this.parametriProdotto,
				headerCell: "myHeaderCellTemplate",
				sortBy: "parametro",
				itemsForFilter: this.parametriProdotto,
				filterType: "select",
				editType: "select",
				editSource: this.parametriProdotto
			},
			{
				field: "beneficiarioID",
				title: this.$i18n.t("generico.beneficiario").toString(),
				values: this.beneficiari,
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				editType: "select",
				editSource: this.beneficiari,
				filterType: "select",
				itemsForFilter: this.beneficiari,
				sortBy: "beneficiario"
			},

			{
				field: "tipoValoreID",
				title: this.$i18n.t("generico.tipoValore").toString(),
				values: this.tipiPremio,
				groupable: true,
				sortBy: "tipoPremio",
				headerCell: "myHeaderCellTemplate",
				editType: "select",
				editSource: this.tipiPremio,
				filterType: "select",
				itemsForFilter: this.tipiPremio
			},
			{ field: "valore", title: this.$i18n.t("generico.valore").toString(), filterType: "numeric", headerCell: "myHeaderCellTemplate" },
			{ field: "startDate", title: this.$i18n.t("generico.startDate").toString(), format: "{0:dd/MM/yyyy}", headerCell: "myHeaderCellTemplate", type: "date", filterType: "daterange", 
			validation: { required: true, msg: this.$i18n.t("generico.campoRichiesto").toString() + ": " + this.$i18n.t("generico.startDate").toString() } 
		},
			{ field: "endDate", title: this.$i18n.t("generico.endDate").toString(), format: "{0:dd/MM/yyyy}", headerCell: "myHeaderCellTemplate", type: "date", filterType: "daterange" },
			{ field: "istanteModifica", title: "Ultima Modifica", width: 90, hidden: true, headerCell: "myHeaderCellTemplate", editDisabled: true, type: "datetime"},
			{ field: "utenteModifica", title: "Utente", width: 90, hidden: true, headerCell: "myHeaderCellTemplate", editDisabled: true},
			{ field: "note", title: "Note", type:"textarea", width: 90, hidden: true, headerCell: "myHeaderCellTemplate", editDisabled: true},
			
			{
				field: "_actions",
				title: " ",
				width: (this.canEdit ? 50 : 0) + (this.canDelete ? 50 : 0),
				cell: "defaultCellTemplate",
				type: "actions_list",
				filterable: false,
				headerCell: "myHeaderCellTemplate",
				hidden: (this.pacchettoID ? true : false) || (this.canEdit == false && this.canDelete == false)
			}
		];
	}

	created() {
		var self = this;
		this.take = 60;
		this.pageable.pageSize = 60;
		this.pageSize = 60;
		if (this.group) {
			this.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = this.group;

		var p = api.getDatiDropDown(api.endpoint.DROPDOWN.BENEFICIARI).then(res => (self.beneficiari = res));

		var parametriProdotto = api.getDatiDropDown(api.endpoint.DROPDOWN.PRODOTTI_COMMISSIONI.replace("{id}", this.prodottoID.toString())).then(res => (self.parametriProdotto = res));

		Promise.all([p, api.getDatiDropDown(api.endpoint.DROPDOWN.TIPI_PREMIO).then(res => self.tipiPremio = res), parametriProdotto])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	getData() {
		this.getGridData(`${_ENDPONT}/${this.prodottoID}`);
	}

	onDelete(item: any) {
		var self = this;
		var message = self.$createElement("div", { domProps: { innerHTML: `<h5>${item.itemID}</h5>${self.$i18n.t("messaggio.confermaCancellazione")}` } }); // h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
		var title = this.$i18n.t("titolo.elimina", [this.$i18n.t("generico.commissioni")]).toString();
		self.deleteGridRow(_ENDPONT, item.itemID, title, [message]);
	}

	addNewRow() {
		let newItem = new CommissioniPolizeItem();
		newItem.prodottoID = this.prodottoID;

		this.onEdit(newItem);
	}

	onEdit(item: any) {
		var self = this;
		self.editItem = Object.assign(new CommissioniPolizeItem(), item);
		self.editSubTitle = "";
		self.editTitle = item.itemID;
		self.showEditModal = true;
	}

	onSaveEdit() {
		var self = this;
		
		var err = (this.$refs.editForm as editForm).validate();
		if (err) {
			var msgs = [];
			for (var i = 0; i < err.length; i++) msgs.push(this.$createElement("div", null, err[i]));

			self.$bvToast.toast(msgs, {
				variant: "danger",
				title: self.$i18n.t("msg.erroreGenerico").toString(),
				solid: true
			});
			return;
		}
		
		var title = this.$i18n.t("msg.salvataggioRiuscito").toString();
		var message = this.$i18n.tc("msg.salvato_iCorrettamente", 1, { obj: this.$i18n.t("generico.commissioni") }).toString();
		self.setGridRow<CommissioniPolizeItem>(_ENDPONT, self.editItem, title, message, self.isNewItem).then(res => {
			self.showEditModal = false;
		});
	}

	get isNewItem(): boolean {
		return (this.editItem || {}).itemID == null || (this.editItem || {}).itemID <= 0;
	}
}
